import { RequestStatus } from "@core-ui/hooks/useApi";
import { useCallback, useEffect, useRef } from "react";

/**
 * Returns a function that resolves once the running publish healthcheck has settled, so that publish does not
 * start a fetch while the healthcheck fetch is still running (ref lock error).
 */
export const useWaitPublishHealth = (status: RequestStatus): (() => Promise<void>) => {
	// only a running request is pending: useApi drops back to Init on a cancelled request, which never answers
	const isPending = status === RequestStatus.Loading;
	const isPendingRef = useRef(isPending);
	isPendingRef.current = isPending;
	const waitersRef = useRef<Array<() => void>>([]);

	useEffect(() => {
		if (isPending) return;
		for (const resolve of waitersRef.current.splice(0)) resolve();
	}, [isPending]);

	return useCallback(() => {
		if (!isPendingRef.current) return Promise.resolve();
		return new Promise<void>((resolve) => waitersRef.current.push(resolve));
	}, []);
};
